import { useState } from "react";
import { Link } from "react-router-dom";
import { gossipArticles } from "@/mocks/gossipArticles";
import { gossipCategories } from "@/mocks/gossipCategories";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";

const tabs = [{ slug: "all", name: "全部瓜料" }, ...gossipCategories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function FeaturedSection() {
  const [active, setActive] = useState("all");

  const list =
    active === "all"
      ? gossipArticles.filter((item) => item.featured).concat(gossipArticles.filter((item) => !item.featured)).slice(0, 6)
      : gossipArticles.filter((item) => item.categorySlug === active);

  return (
    <section id="featured" className="mx-auto max-w-shell scroll-mt-28 px-4 py-14 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Picks"
        title="精选瓜料"
        description="不是所有动静都值得追。这里挑出信息量更足、脉络更清楚的几条，适合慢慢看完前因后果。"
        action={
          <Link
            to="/about"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            了解编辑标准 <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="mt-8 flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => setActive(tab.slug)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-label transition-colors ${
              active === tab.slug
                ? "bg-foreground-950 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {list.length > 0 ? (
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      ) : (
        <p className="mt-8 rounded-lg border border-dashed border-background-300 px-6 py-10 text-center text-sm text-foreground-500">
          这个栏目还在整理中，先去看看其他瓜料吧。
        </p>
      )}

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {gossipArticles.slice(0, 2).map((article) => (
          <ArticleCard key={article.slug} article={article} variant="wide" />
        ))}
      </div>
    </section>
  );
}